import { Component, OnInit } from '@angular/core';
import {HotelService} from '../services/hotel.service';
import { Hotel } from '../hotel';

import { MessageService } from '../services/message.service';

@Component({
  selector: 'app-edithotel',
  templateUrl: './edithotel.component.html',
  styleUrls: ['./edithotel.component.css']
})
export class EdithotelComponent implements OnInit {

  model = new Hotel;

  constructor(private hotelService:HotelService, private messageService:MessageService) { }
  profiles:any; rates:any;
  ngOnInit() {
    this.editHotel();
    this.getUnits();
  }
  editHotel()
  {
    this.hotelService
        .getEditHotel()
        .subscribe( hotels => {
          this.profiles = hotels;
          //console.log(profiles);
        })
  }
  obj:any;
  editrate()
  {
    this.obj = { "hotelid":this.model.hotelid};
    //console.log(this.obj);
    this.hotelService
        .assignRate(this.obj)
        .subscribe( rates => {
          this.rates = rates[0];
          console.log(rates[0]);
          Object.assign(this.model, this.rates);
          
        })
  }

  editHotelMaterial()
  {
    //console.log(this.model);
  
    this.hotelService
        .editHotelMaterial(this.model)
        .subscribe( response => {
          //console.log(response);
          $('#myform').trigger("reset");
          this.editHotel();
          $("html, body").animate({ scrollTop: 0 }, "slow");
          
          this.messageService.showMessage('div#msg','alert-info',response.response,'glyphicon-ok')
        })
  }

  units: any;
  getUnits(){
    this.hotelService
      .getUnits({})
      .subscribe(profiles => {
        this.units = profiles;
        // console.log(this.profiles);
      })
  }
}



// WEBPACK FOOTER //
// D:/xampp/htdocs/tejashree/src/app/edithotel/edithotel.component.ts